import * as React from 'react';
export const commercetoolsSvg = React.forwardRef(function commercetoolsSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6 21.877v-10.04a.36.36 0 0 1 .538-.314l8.635 5.02c.222.13.359.368.359.625v10.04a.359.359 0 0 1-.538.313l-8.635-5.018A.723.723 0 0 1 6 21.877Z',
      fill: '#6359FF',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm7.12 10.039 8.501-4.942a.712.712 0 0 1 .717 0l8.5 4.942a.453.453 0 0 1 0 .781l-8.5 4.942a.712.712 0 0 1-.717 0l-8.5-4.942a.453.453 0 0 1 0-.781Z',
      fill: '#FFC806',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.428 27.21v-9.311c0-.279.298-.452.538-.313l7.872 4.577a.453.453 0 0 1 0 .782l-7.872 4.577a.359.359 0 0 1-.538-.313Z',
      fill: '#0BBFBF',
    }),
  );
});
commercetoolsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var commercetools = {
  category: 'brand',
  colorable: false,
  name: 'commercetools',
  svg: commercetoolsSvg,
};
